import { Flex, FlexProps, IconButton } from '@chakra-ui/react';
import { Menu } from 'lucide-react';

interface NavigationProps extends FlexProps {
    onOpen: () => void;
    isOpen: boolean;
}

export function Navigation({ onOpen, isOpen }: NavigationProps) {
    return (
        <Flex px={{ base: 0, md: 0 }} position="absolute" top="4px" zIndex={9999}>
            <IconButton
                display={{ base: isOpen ? 'none' : 'flex', md: 'none' }}
                onClick={onOpen}
                variant="ghost"
                bg="transparent"
                color="var(--chakra-body-text)"
                aria-label="open menu">
                <Menu />
            </IconButton>
        </Flex>
    );
}
